import { render } from "./page-header-content.vue?vue&type=template&id=161ffade"
import script from "./page-header-content.vue?vue&type=script&lang=ts"
export * from "./page-header-content.vue?vue&type=script&lang=ts"
script.render = render

export default script